
import { harryMediaArray } from './harryMedia'
import { hermioneReviewerProfile, dumbledoreReviewerProfile, ronReviewerProfile } from './harryReviewers'
import { ronBio, hermioneBio, dumbledoreBio, harryBio } from './harryBios'
import { harryDatingProfileHinge, harryDatingProfileBumble, harryDatingProfileTinder } from './harryDatingProfiles'

export const harryUser = {
  _id: 'harryUserId',
  email: 'harry@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: false,
  reviewerProfilesToSelectFrom: [
    { ...hermioneReviewerProfile },
    { ...dumbledoreReviewerProfile },
    { ...ronReviewerProfile }
  ],
  media: [ ...harryMediaArray ],
  bio: { ...harryBio },
  datingProfiles: [
    { ...harryDatingProfileHinge },
    { ...harryDatingProfileBumble },
    { ...harryDatingProfileTinder }
  ],
  reviewerProfile: {},
}

export const hermioneUser = {
  _id: 'hermioneUserId',
  email: 'hermione@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...hermioneBio },
  datingProfiles: [],
  reviewerProfile: { ...hermioneReviewerProfile },
}

export const dumbledoreUser = {
  _id: 'dumbledoreUserId',
  email: 'dumbledore@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...dumbledoreBio },
  datingProfiles: [],
  reviewerProfile: { ...dumbledoreReviewerProfile },
}

export const ronUser = {
  _id: 'ronUserId',
  email: 'ron@email.com',
  acceptedTOS: true,
  subscriptionIsActive: true,
  isReviewer: true,
  reviewerProfilesToSelectFrom: [],
  media: [],
  bio: { ...ronBio },
  datingProfiles: [],
  reviewerProfile: { ...ronReviewerProfile },
}
